
<template>
  <div class="prescription_record">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <!-- <van-tabs
      v-model="activeName"
      :line-width="'20px'"
      color="#807AF4"
      title-active-color="#807AF4"
      :sticky="true"
      :border="false"
      @click="clickTabs"
    > -->
    <!-- <van-tab title="待审核">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh(1)">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="全部加载完毕"
            @load="getData"
            class="item_list"
          >
            <div class="item" v-for="item in dataList" :key="item.LoInquiryId" @click="goto(item.LoInquiryId)">
              <img src="@/images/user_man.png" class="head_img" v-if="item.Sex==1" />
              <img src="@/images/user_woman.png" class="head_img" v-if="item.Sex==2" />
              <div class="detail">
                <div class="flex1">
                  <div class="flex2">
                    <div class="name flex2">
                      <div class="name_box line1">{{item.Name}}</div>
                      <div class="phone_box">{{item.Mobilephone}}</div>
                    </div>
                  </div>

                  <div class="type type2" v-if="item.PharAuditNameUrl">已审核</div>
                  <div class="type" v-if="!item.PharAuditNameUrl">待审核</div>
                </div>
                <div class="flex2">
                  <div class="age">处方来源：{{item.AppkeyName}}</div>
                </div>

                <div class="create_date">提交时间：{{item.CreateDate}}</div>
                <div class="flex2 more_btn">
                  <div :class="item.PharAuditNameUrl?'flex2 more_btn_div more_btn_div_active':'flex2 more_btn_div'">
                    <img src="@/images/u652.png" v-if="item.PharAuditNameUrl" />
                    <span>审核</span>
                  </div>

                  <div :class="item.PharDispensingNameUrl?'flex2 more_btn_div more_btn_div_active':'flex2 more_btn_div'">
                    <img src="@/images/u652.png" v-if="item.PharDispensingNameUrl" />
                    <span>调配</span>
                  </div>
                  <div :class="item.PharReviewNameUrl?'flex2 more_btn_div more_btn_div_active':'flex2 more_btn_div'">
                    <img src="@/images/u652.png" v-if="item.PharReviewNameUrl" />
                    <span>复核/发药</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>  -->
    <!-- <van-tab title="全部处方"> -->
    <van-pull-refresh
      v-model="isLoading2"
      @refresh="onRefresh(2)"
      @load="getData"
    >
      <div class="flex1 search_box search_box_1">
        <div class="ming_flex2">
          <div
            :class="
              inquiryStatus == 1 ? ' inquiry_status_active' : 'inquiryStatus'
            "
            @click="inquiryStitusClick(1)"
          >
            全部
            <div :class="inquiryStatus == 1 ? 'inquiryStatus_bb' : ''"></div>
          </div>
          <div
            :class="
              inquiryStatus == 4
                ? 'inquiryStatus inquiry_status_active'
                : 'inquiryStatus'
            "
            @click="inquiryStitusClick(4)"
          >
            待审核
            <div :class="inquiryStatus == 4 ? 'inquiryStatus_bb' : ''"></div>
          </div>
          <div
            :class="
              inquiryStatus == 2
                ? 'inquiryStatus inquiry_status_active'
                : 'inquiryStatus'
            "
            @click="inquiryStitusClick(2)"
          >
            待调配
            <div :class="inquiryStatus == 2 ? 'inquiryStatus_bb' : ''"></div>
          </div>
          <div
            :class="
              inquiryStatus == 3
                ? 'inquiryStatus inquiry_status_active'
                : 'inquiryStatus'
            "
            @click="inquiryStitusClick(3)"
          >
            待复核/发药
            <div :class="inquiryStatus == 3 ? 'inquiryStatus_bb' : ''"></div>
          </div>
        </div>
      </div>
      <van-list
        v-model="finished2"
        :finished="finished2"
        finished-text="全部加载完毕"
        @load="getHisData"
        class="item_list mar_1"
      >
        <div
          class="item"
          v-for="item in allList"
          :key="item.LoInquiryId"
          @click="goto(item.LoInquiryId)"
        >
          <img
            src="@/images/user_man.png"
            class="head_img"
            v-if="item.Sex == 1"
          />
          <img
            src="@/images/user_woman.png"
            class="head_img"
            v-if="item.Sex == 2"
          />
          <div class="detail">
            <div class="flex1">
              <div class="flex2">
                <div class="name flex2">
                  <div class="name_box line1">{{ item.Name }}</div>
                  <div class="phone_box">{{ item.Mobilephone }}</div>
                </div>
              </div>
              <div class="type type2" v-if="item.PharAuditNameUrl">已审核</div>
              <div class="type" v-if="!item.PharAuditNameUrl">待审核</div>
            </div>
            <div class="flex2">
              <div class="age">处方来源：{{ item.AppkeyName }}</div>
            </div>

            <div class="create_date">提交时间：{{ item.CreateDate }}</div>
            <div class="flex2 more_btn">
              <div
                :class="
                  item.PharAuditNameUrl
                    ? 'flex2 more_btn_div more_btn_div_active'
                    : 'flex2 more_btn_div'
                "
              >
                <span>审核</span>
                <img src="@/images/u652.png" v-if="item.PharAuditNameUrl" />
              </div>

              <div
                :class="
                  item.PharDispensingNameUrl
                    ? 'flex2 more_btn_div more_btn_div_active'
                    : 'flex2 more_btn_div'
                "
              >
                <span>调配</span>
                <img
                  src="@/images/u652.png"
                  v-if="item.PharDispensingNameUrl"
                />
              </div>
              <div
                :class="
                  item.PharReviewNameUrl
                    ? 'flex2 more_btn_div more_btn_div_active'
                    : 'flex2 more_btn_div'
                "
              >
                <span>复核/发药</span>
                <img src="@/images/u652.png" v-if="item.PharReviewNameUrl" />
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- </van-tab> -->
    <!-- </van-tabs> -->
  </div>
</template>

<script>
import { GetOrderList } from "@/utils/api.js";
import { getCookie, CurentTime, computedAges } from "@/utils/common.js";
import { List, Toast, PullRefresh } from "vant";
export default {
  data() {
    return {
      inquiryStatus: 1,
      app_mobile: "",
      isLoading2: false,
      isLoading: false,
      allList: [],
      allPage: 1,
      loading2: false,
      finished2: true,
      activeName: 0,
      maxDate: new Date(),
      currentDate1: new Date(),
      currentDate2: new Date(),
      showStart: false,
      showEnd: false,
      startDate: "请选择",
      endDate: "请选择",
      ModeType: 1,
      clear: true,
      finished: true,
      loading: false,
      reasonTip: "", //拒绝原因
      InquiryId: "",
      refuse: false,
      detail: {},
      woman: "@/images/user_woman.png",
      man: "@/images/user_man.png",
      dataList: [],
      keyWords: "",
      page: 1,
      isAuth: -1,
      sloading: false,
    };
  },

  methods: {
    goto(id) {
      this.$router.push({
        path: "/prescriptionDetail",
        query: {
          InquiryId: id,
        },
      });
    },

    inquiryStitusClick(status) {
      if (this.inquiryStatus == status) return;
      if (this.sloading) return;
      this.inquiryStatus = status;
      this.allPage = 1;
      this.allList = [];
      if (status == 1) {
        this.isAuth = -1;
      } else if (status == 2) {
        this.isAuth = 1;
      } else if (status == 3) {
        this.isAuth = 2;
      } else if (status == 4) {
        this.isAuth = 0;
      }
      this.getData();
    },
    onRefresh(type) {
      if (type == 1) {
        this.page = 1;
        this.dataList = [];
        this.getData();
      } else if (type == 2) {
        this.allPage = 1;
        this.allList = [];
        this.getData();
      }
    },

    clickTabs(v) {
      if (this.loading) return;
      if (v == 0) {
        this.isAuth = 0;
        this.page = 1;
        this.dataList = [];
      } else if (v == 1) {
        this.isAuth = -1;
        this.inquiryStatus = 1;
        this.allList = [];
        this.allPage = 1;
      }

      this.getData();
    },

    touchmove() {},
    onSubmit() {},

    // 请求列表
    getData() {
      if (this.sloading) {
        return;
      }
      let active = this.activeName;
      this.sloading = true;
      let pageIndex = this.activeName == 0 ? this.allPage : this.page;
      GetOrderList({
        pageIndex,
        pageSize: 10,
        isAuth: this.isAuth,
      })
        .then((res) => {
          this.sloading = false;
          if (res.code == 1) {
            // res.data.list.map(item=>{
            //   item.CreateDate =   CurentTime(item.CreateDate)
            // })
            // debugger
            if (pageIndex == 1) {
              this.dataList = [];
              this.allList = [];
              this.finished2 = false;
            }

            if (active == 10) {
              this.dataList = [...this.dataList, ...res.data.list];
              this.page += 1;
              this.isLoading = false;
              if (this.dataList.length >= res.data.total) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.allList = [...this.allList, ...res.data.list];
              this.allPage += 1;
              this.isLoading2 = false;
              if (this.allList.length >= res.data.total) {
                this.finished2 = true;
              } else {
                this.finished2 = false;
              }
            }

            this.loading = false;
          } else {
            Toast(res.msg);
            this.finished2 = true
          }
          this.loading = false;
        })
        .catch((err) => {
          this.sloading = false;
        });
    },
    getHisData(values) {
      this.getData();
    },
    // },
  },
  mounted() {
    // localStorage.setItem("access_token","efc05a172814851c020919dc267a3179")
    // localStorage.setItem("uniqueId","2bf4a9ef413d9a1e")

    window.watchs();
    document.title = this.$route.meta.title;
  },
  activated() {
    this.getData();
  },
};
</script>

<style scoped="scoped"  lang="scss" src="@/scss/prescription_record.scss">
</style>